// extracted by mini-css-extract-plugin
module.exports = {"generateBtn":"MarkdownToPPT_generateBtn__0ki9h","tooltipWrapper":"MarkdownToPPT_tooltipWrapper__uCYgN","spinner":"MarkdownToPPT_spinner__Ve5tc","spin":"MarkdownToPPT_spin__0wl5S"};